import { createTranslation } from '@choffmeister/i18next'
import { i18n, TFunction } from 'i18next'

import common from './common.json'
import AppsBlock from './components/AppsBlock.json'
import CTAStrip from './components/CTAStrip.json'
import CustomersBlock from './components/CustomersBlock.json'
import IntegrationsAndAiBlock from './components/IntegrationsAndAiBlock.json'
import IntegrationsAndSupportBlock from './components/IntegrationsAndSupportBlock.json'
import IntegrationsBlock from './components/IntegrationsBlock.json'
import Intro from './components/Intro.json'
import Manifesto from './components/Manifesto.json'
import Partners from './components/Partners.json'
import Pricing from './components/Pricing.json'
import SecurityAndPrivacyBlock from './components/SecurityAndPrivacyBlock.json'
import SupportAndSecurityBlock from './components/SupportAndSecurityBlock.json'
import TemplatesBlock from './components/TemplatesBlock.json'
import VideoGallery from './components/VideoGallery.json'
import WhyAirfocus from './components/WhyAirfocus.json'
import aePages from './pages/aePages.json'
import demo from './pages/book-a-demo.json'
import competitors from './pages/competitors.json'
import homepage from './pages/homepage.json'
import pricing from './pages/pricing.json'
import product from './pages/product.json'
import theAirfocusWay from './pages/the-airfocus-way.json'
import adPages from './pages/try-now.json'

const resources = {
  ...common,

  // components
  AppsBlock,
  CustomersBlock,
  CTAStrip,
  IntegrationsBlock,
  IntegrationsAndAiBlock,
  IntegrationsAndSupportBlock,
  Intro,
  Manifesto,
  Partners,
  Pricing,
  SecurityAndPrivacyBlock,
  SupportAndSecurityBlock,
  TemplatesBlock,
  VideoGallery,
  WhyAirfocus,

  // pages
  adPages,
  aePages,
  competitors,
  demo,
  homepage,
  pricing,
  product,
  theAirfocusWay,
} as const

type Resources = typeof resources

type SafeUseTranslationResponse = {
  i18n: i18n
  ready: boolean
  t: TFunction<keyof Resources>
}

const { useTranslation: useOriginalTranslation } = createTranslation(resources)

export const useTranslation = (): SafeUseTranslationResponse => {
  const { t, i18n, ready } = useOriginalTranslation()

  return {
    i18n: i18n as i18n,
    ready: ready as boolean,
    t: t as TFunction<keyof Resources>,
  }
}
